
const engineeringManagerRouter = [
  {
    path: '/engineering-manager',
    name: 'engineering-manager',
    component: () => import('@/views/wxapp/engineering-manager'),
    redirect: '/engineering-manager/home',
    meta: {
      title: '工程部经理'
    },
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/wxapp/engineering-manager/home'),
        meta: {
          title: '工程部经理'
        },
        children: [
          {
            path: 'workbench',
            name: 'engineering-manager_workbench',
            component: () => import('@/views/wxapp/engineering-manager/workbench'),
            meta: {
              title: '工作台'
            }
          },
          {
            path: 'business-data',
            name: 'engineering-manager_business-data',
            component: () => import('@/views/wxapp/engineering-manager/business-data'),
            meta: {
              title: '业务数据看板'
            }
          }
        ]
      },
      {
        path: 'engineering-list',
        name: 'engineering-list',
        component: () => import('@/views/wxapp/engineering-manager/engineering-list/index'),
        meta: {
          title: '工程审核'
        }
      },
      {
        path: 'engineering-examine',
        name: 'engineering-examine',
        component: () => import('@/views/wxapp/engineering-manager/engineering-examine'),
        meta: {
          title: '工程审核'
        }
      },
      {
        path: 'personnel',
        name: 'personnel',
        component: () => import('@/views/wxapp/engineering-manager/personnel'),
        meta: {
          title: '人员管理'
        }
      },
      {
        path: 'informationList',
        name: 'informationList',
        component: () => import('@/views/wxapp/engineering-manager/informationList'),
        meta: {
          title: '消息列表'
        }
      },
      {
        path: 'siteDetails',
        name: 'siteDetails',
        component: () => import('@/views/wxapp/engineering-manager/site-details'),
        meta: {
          title: '工地管理详情'
        }
      },
      {
        path: 'siteList',
        name: 'siteList',
        component: () => import('@/views/wxapp/engineering-manager/site-details/list'),
        meta: {
          title: '工地管理列表'
        }
      },
      {
        path: 'add-personal',
        name: 'AddPersonPage',
        component: () => import('@/views/wxapp/engineering-manager/personnel/addPerson'),
        meta: {
          title: '工地管理列表'
        }
      },
      {
        path: 'change-audit',
        name: 'ChangeAudit',
        component: () => import('@/views/wxapp/engineering-manager/changeAudit'),
        meta: {
          title: '变更审核列表'
        }
      },
      {
        path: 'change-examine',
        name: 'ChangeExamine',
        component: () => import('@/views/wxapp/engineering-manager/changeAudit/examine'),
        meta: {
          title: '变更审核'
        }
      }
    ]
  }
]
export default engineeringManagerRouter
